import { createFileRoute } from '@tanstack/react-router';
import { RouteName, TextKey } from '@mews-commander/enums';
import { SecurityDashboard } from '@mews-commander/modules/src/modules/security';
import { DialogProvider, PortfolioLayout } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Security/Index/')({
    beforeLoad: ({ context: { checkPrivilege } }) => {
        checkPrivilege('admin');
    },
    component: () => (
        <DialogProvider>
            <PortfolioLayout>
                <SecurityDashboard />
            </PortfolioLayout>
        </DialogProvider>
    ),
    staticData: {
        title: TextKey.Security,
        routeName: RouteName.SecuritySettings,
        owner: MewsTeam.Users,
        type: RouteType.Frontend,
    },
});
